import { LookalikeCard } from '@aibees/elephant/feature/sidebar-lookalike/components/lookalike-card';
import { SearchDataNotFoundDrawer } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Stack } from '@mui/material';
import { memo } from 'react';
import { EmployeeCardHeader } from './components/employee-card-header';
import { SearchBar } from './components/search-bar';
import { useEmployeesData } from './hooks/use-employees-data';
import * as Styled from './styles';
import * as SX from './sx';
import type { EmployeesProps as Props } from './types';
import { SearchType } from '@aibees/elephant/types';

export const Employees = memo(({ className }: Props) => {
  const { filteredData, isLoading, emptyData, handleSearch } =
    useEmployeesData();

  return (
    <Styled.Wrapper className={classnames('Employees', className)} sx={SX.root}>
      <EmployeeCardHeader />

      <Stack p={1} gap={1}>
        <SearchBar onSearch={handleSearch} />

        {isLoading
          ? Array.from({ length: 10 }).map((_, index) => (
              <LookalikeCard
                key={index}
                isLoading
                searchType={SearchType.People}
              />
            ))
          : filteredData?.map((item) => (
              <LookalikeCard
                key={item.id}
                item={item}
                isLoading={false}
                searchType={SearchType.People}
                isSidebar
              />
            ))}
      </Stack>
      {emptyData && (
        <SearchDataNotFoundDrawer
          title="No Employee Data Available!"
          icon="people-outline"
        />
      )}
    </Styled.Wrapper>
  );
});

Employees.displayName = 'Employees';
